export var FieldSectionType = /*#__PURE__*/ function(FieldSectionType) {
    FieldSectionType["Project"] = "PROJECT";
    FieldSectionType["ProjectPhase"] = "PROJECT_PHASE";
    FieldSectionType["Task"] = "TASK";
    FieldSectionType["Users"] = "USERS";
    FieldSectionType["Financial"] = "FINANCIAL";
    FieldSectionType["Sprint"] = "SPRINT";
    FieldSectionType["Company"] = "COMPANY";
    FieldSectionType["Timeoff"] = "TIMEOFF";
    FieldSectionType["Invoice"] = "INVOICE";
    FieldSectionType["CreditNote"] = "CREDIT_NOTE";
    FieldSectionType["Budget"] = "PROJECT_FINANCIALS_BUDGET";
    FieldSectionType["Epic"] = "EPIC";
    FieldSectionType["Backlog"] = "BACKLOG";
    FieldSectionType["TimeEntry"] = "TIME_ENTRY";
    FieldSectionType["Expense"] = "EXPENSE";
    FieldSectionType["ResourceAllocation"] = "RESOURCE_ALLOCATION";
    FieldSectionType["Sheet"] = "SHEET";
    FieldSectionType["SheetColumn"] = "SHEET_COLUMN";
    FieldSectionType["Reports"] = "REPORTS";
    return FieldSectionType;
}({});
export var FieldSectionSubType = /*#__PURE__*/ function(FieldSectionSubType) {
    FieldSectionSubType["Default"] = "DEFAULT";
    FieldSectionSubType["Skill"] = "SKILL";
    FieldSectionSubType["ExternalUser"] = "EXTERNAL_TEAM_MEMBER";
    FieldSectionSubType["InvoiceProject"] = "INVOICE_PROJECT";
    return FieldSectionSubType;
}({});
export var FieldTypeDisplay = /*#__PURE__*/ function(FieldTypeDisplay) {
    FieldTypeDisplay["Level"] = "LEVEL";
    return FieldTypeDisplay;
}({});
/** Sheet field/column sections use `fieldSectionLabel`; others use `fieldSectionName`. */ export const isSheetFieldSectionType = (type)=>type === "SHEET" || type === "SHEET_COLUMN";
/**
 * Resolves the name to render for a section. Sheet field/column sections carry a
 * backend-generated `fieldSectionName`, so their human-facing name lives in
 * `fieldSectionLabel`. Every other section type uses `fieldSectionName`.
 */ export const getFieldSectionDisplayName = (section)=>{
    var _section_fieldSectionLabel, _section_fieldSectionName;
    return isSheetFieldSectionType(section.fieldSectionType) ? (_section_fieldSectionLabel = section.fieldSectionLabel) !== null && _section_fieldSectionLabel !== void 0 ? _section_fieldSectionLabel : '' : (_section_fieldSectionName = section.fieldSectionName) !== null && _section_fieldSectionName !== void 0 ? _section_fieldSectionName : '';
};
